var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatFlat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.8889,
    height: 40,
    transform: "translate(4.66602 2)",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6672_16233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 6.56617C4.66602 4.35703 6.45688 2.56616 8.66602 2.56616H48.7119L53.5946 7.41496V37.4805C53.5946 39.6897 51.8037 41.4805 49.5946 41.4805H8.66601C6.45687 41.4805 4.66602 39.6897 4.66602 37.4805V6.56617Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3145 28.6622C33.3145 27.5577 34.2099 26.6622 35.3145 26.6622H49.4213C50.5258 26.6622 51.4213 27.5577 51.4213 28.6622V37.1622C51.4213 38.2668 50.5258 39.1622 49.4213 39.1622H35.3145C34.2099 39.1622 33.3145 38.2668 33.3145 37.1622V28.6622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9302 33.1021V34.2768H12.1179V33.1021H10.9302ZM10.4551 33.0727C10.4551 32.8294 10.6545 32.6322 10.9005 32.6322H12.1476C12.3936 32.6322 12.5931 32.8294 12.5931 33.0727V34.3061C12.5931 34.5494 12.3936 34.7466 12.1476 34.7466H10.9005C10.6545 34.7466 10.4551 34.5494 10.4551 34.3061V33.0727ZM10.9302 35.6863V36.861H12.1179V35.6863H10.9302ZM10.4551 35.6569C10.4551 35.4136 10.6545 35.2164 10.9005 35.2164H12.1476C12.3936 35.2164 12.5931 35.4136 12.5931 35.6569V36.8904C12.5931 37.1336 12.3936 37.3309 12.1476 37.3309H10.9005C10.6545 37.3309 10.4551 37.1336 10.4551 36.8904V35.6569ZM13.5437 34.2768V33.1021H14.7314V34.2768H13.5437ZM13.514 32.6322C13.268 32.6322 13.0686 32.8294 13.0686 33.0727V34.3061C13.0686 34.5494 13.268 34.7466 13.514 34.7466H14.7611C15.0071 34.7466 15.2065 34.5494 15.2065 34.3061V33.0727C15.2065 32.8294 15.0071 32.6322 14.7611 32.6322H13.514ZM13.3063 35.2164C13.4376 35.2164 13.5441 35.3216 13.5441 35.4514V36.1562C13.5441 36.2859 13.4376 36.3911 13.3063 36.3911C13.175 36.3911 13.0686 36.2859 13.0686 36.1562V35.4514C13.0686 35.3216 13.175 35.2164 13.3063 35.2164ZM14.4939 35.4514C14.4939 35.3216 14.3875 35.2164 14.2563 35.2164C14.1251 35.2164 14.0188 35.3216 14.0188 35.4514V35.9118L14.0185 35.9221L14.0188 35.9325V36.861H13.3061C13.1749 36.861 13.0686 36.9662 13.0686 37.0959C13.0686 37.2257 13.1749 37.3309 13.3061 37.3309H14.2563C14.3875 37.3309 14.4939 37.2257 14.4939 37.0959V36.1571H14.9688C15.0999 36.1571 15.2063 36.0519 15.2063 35.9221C15.2063 35.7924 15.0999 35.6872 14.9688 35.6872H14.4939V35.4514ZM15.2063 36.6263C15.2063 36.4965 15.0999 36.3913 14.9685 36.3913C14.8372 36.3913 14.7308 36.4965 14.7308 36.6263V37.0961C14.7308 37.2259 14.8372 37.3311 14.9685 37.3311C15.0999 37.3311 15.2063 37.2259 15.2063 37.0961V36.6263Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43359 7.99158C7.43359 6.88701 8.32902 5.99158 9.43359 5.99158H26.9338C28.0384 5.99158 28.9338 6.88701 28.9338 7.99158V26.6632H11.743C9.36296 26.6632 7.43359 24.7339 7.43359 22.3539V7.99158Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1842,
    cy: 13.8493,
    rx: 5.34629,
    ry: 5.2826,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43359 18.9116L25.2486 27.016C25.5719 27.1631 25.7793 27.4854 25.7793 27.8405C25.7793 28.3048 25.4029 28.6812 24.9386 28.6812H11.743C9.36297 28.6812 7.43359 26.7519 7.43359 24.3719V18.9116Z",
    fill: "#AEAFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9336 16.6794L7.43338 25.7478V26.6811C7.43338 27.7857 8.32881 28.6811 9.43338 28.6811H26.9336C28.0382 28.6811 28.9336 27.7857 28.9336 26.6811V16.6794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 9.62793,
    width: 11.5905,
    height: 2.17735,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 13.2166,
    width: 8.5473,
    height: 0.857127,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 19.0688,
    width: 8.5473,
    height: 0.857128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 14.6797,
    width: 9.88978,
    height: 0.857129,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 20.532,
    width: 9.88978,
    height: 0.85713,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 16.1427,
    width: 8.99494,
    height: 0.857128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 21.995,
    width: 8.99494,
    height: 0.857128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 17.6058,
    width: 10.3193,
    height: 0.857129,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3145,
    y: 23.4581,
    width: 10.3193,
    height: 0.857126,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5156,
    y: 29.912,
    width: 11.5905,
    height: 1.16173,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5156,
    y: 32.485,
    width: 8.5473,
    height: 0.857128,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5156,
    y: 33.9481,
    width: 9.88978,
    height: 0.857128,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5156,
    y: 35.4111,
    width: 8.99494,
    height: 0.857124,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1836,
    y: 33.0897,
    width: 8.50662,
    height: 0.857128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1836,
    y: 34.5527,
    width: 7.73693,
    height: 0.857124,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1836,
    y: 36.0159,
    width: 7.73693,
    height: 0.857128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9062 2.51953L53.6002 7.21784H50.9062C49.8017 7.21784 48.9062 6.32241 48.9062 5.21784V2.51953Z",
    fill: "#4F5B94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6672_16233",
    x: 0.666016,
    y: 0.519531,
    width: 56.9336,
    height: 46.9609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0588235 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6672_16233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6672_16233",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatFlat);
export default __webpack_public_path__ + "static/media/format-flat.ddd3f231d4b02e3341b91febf30a722f.svg";
export { ForwardRef as ReactComponent };